import restClient from "../restClient";

export const getScheduleDashboardRuns = async ({ limit = 10, year, month } = {}) => {
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        limit,
        ...(year ? { year } : {}),
        ...(month ? { month } : {}),
      },
    };
    const response = await restClient.get("report-schedules/dashboard-runs", config);
    const runs = response.data?.data || [];
    if (!year || !month) return runs;

    const monthKey = `${year}-${String(month).padStart(2, "0")}`;
    return runs.filter((run) => {
      const ranInMonth = run?.ran_at && String(run.ran_at).slice(0, 7) === monthKey;
      const nextInMonth = run?.next_run_at && String(run.next_run_at).slice(0, 7) === monthKey;
      return ranInMonth || nextInMonth;
    });
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const getReportScheduleRuns = async (reportId, { year, month, scheduleId } = {}) => {
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        report_id: reportId,
        year,
        month,
        ...(scheduleId ? { schedule_id: scheduleId } : {}),
      },
    };
    const response = await restClient.get("report-schedules/runs", config);
    return response.data?.data || [];
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const downloadScheduleExportFile = async (uploadFileId, fileName = "schedule-export.csv") => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}report-schedules/export-files/${uploadFileId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `HTTP error! status: ${response.status}`);
  }

  const blob = await response.blob();
  const safeName = String(fileName || "schedule-export.csv").replace(/[^\w.\-]+/g, "_");
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = safeName.endsWith(".csv") ? safeName : `${safeName}.csv`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(url);
};
